module.exports = __webpack_public_path__ + "static/img/banner_qyjs.77f9ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/banner_qyjs.png
// module id = KR08
// module chunks = 1